module.exports = __webpack_public_path__ + "pathways-graph-bg.62d2555bd1094cda312b7a5419875325.png";